import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import AuthApi from '../../api/auth/AuthApi'
import { AppleRegistrationDto } from '../../api/auth/types'
import { HttpError } from '../../types/common'
import { showErrorToast } from '../../utils/errors'
import { useNavigate } from 'react-router-dom'
import store from '../../redux/store'
import { logIn } from '../../redux/storageToolkit'

const authApi = AuthApi.getInstance()

export function useAppleRegister() {
  const texts = useTranslation().t
  const navigate = useNavigate()

  const mutation = useMutation(async (body: AppleRegistrationDto) => {
    const { data } = await authApi.appleRegister(body)
    return data
  }, {
    onSuccess: (data) => {
      store.dispatch(logIn(data))
      navigate('/')
    },
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}